module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/top/banner02-e1118cefb0d45a81859b9a7b46cc2f5e.png";